
export default {
  name: "LogOut",
};
